<template>
  <d-page>
    <div class="base">
      <div class="logo">
        <img class="logo-img" src="@/assets/images/icon/logo.png" alt="" />
        <p>矿美贵州 v1.0.0</p>
      </div>
      <div class="notice">
        <p>任何个人或单位如果同时符合以下两个条件：</p>
        <p>1. 权利人发现网络用户利用网络服务侵害其合法权益；</p>
        <p>2. 百度的搜索引擎系统以自动检索方式而链接到第三方网站的内容侵犯了上述权利人的合法权益。</p>
        <p>请上述个人或单位务必以书面的通讯方式向百度提交通知。</p>
      </div>

      <ul class="base-info">
        <li class="field" @click="jump('user_agreement')">
          <p>用户协议</p>
          <img class="field-right" src="@/assets/images/icon/right.png" alt="" />
        </li>

        <li class="field" @click="jump('privacy_policy')">
          <p>隐私政策</p>
          <img class="field-right" src="@/assets/images/icon/right.png" alt="" />
        </li>
      </ul>
    </div>

    <div class="footer">
      <img class="footer-img" src="@/assets/images/icon/logo.png" alt="" />
      <p>扫码下载“矿美贵州”app</p>
    </div>
  </d-page>
</template>

<script>
  export default {
    name: 'about',
    data() {
      return {}
    },
    methods: {
      jump(key) {
        this.$router.push({ path: '/h5cms/index', query: { key } })
      }
    }
  }
</script>

<style scoped lang="scss">
  .base {
    width: 351px;
    background: #ffffff;
    border-radius: 8px;
    margin: 12px auto;
    padding: 12px;

    .logo {
      width: 215px;
      margin: 0 auto;
      padding-top: 36px;
      text-align: center;

      &-img {
        width: 215px;
        height: 52px;
      }

      p {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #cccccc;
        line-height: 17px;
      }
    }

    .notice {
      margin-top: 24px;

      p {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 17px;
      }
    }

    .base-info {
      margin-top: 24px;

      .field {
        display: flex;
        align-items: center;
        position: relative;
        border-top: 1px solid #e9e9e9;
        border-bottom: 1px solid #e9e9e9;
        box-sizing: border-box;
        padding-top: 16px;
        padding-bottom: 16px;

        p {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }

        .field-right {
          position: absolute;
          right: 12px;
          width: 14px;
          height: 14px;
        }

        &:last-child {
          border: 0;
        }
      }
    }
  }

  .footer {
    text-align: center;
    margin-top: 60px;
    padding-bottom: 60px;

    &-img {
      width: 120px;
      height: 120px;
    }

    p {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #333333;
      line-height: 20px;
    }
  }
</style>
